// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-btn-wrapper .ant-switch-checked{\n    background-color:var(--color-success);\n}", "",{"version":3,"sources":["webpack://./src/components/Buttons/SwitchBtn/SwitchBtn.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;AACzC","sourcesContent":[".switch-btn-wrapper .ant-switch-checked{\n    background-color:var(--color-success);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
